module.exports = __webpack_public_path__ + "static/media/head_img_m.8e876574.png";